export const initDoctors = ["Лікар_1", "Лікар_2", "Лікар_3"];
